var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-header text-center mb-12"},[_c('h1',{domProps:{"innerHTML":_vm._s(_vm.title)}}),_c('div',{staticClass:"section-header__divider"}),_c('div',{staticClass:"section-header__text primary--text",domProps:{"innerHTML":_vm._s(_vm.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }